@if (isValue()) {
  {{ value !== undefined ? (value | json) : 'undefined' }}
} @else if (isArray() || keys().length > 0) {
  <span>{{ isArray() ? '[' : '{' }}</span>
  <div class="_block">
    @for (item of getChildren(); track $index) {
      @if (isValue(item[1]) || item === undefined || keys(item[1]).length === 0) {
        <div>
          <span>{{ item[0] | json }}:&nbsp;</span>
          <wct-json
            [value]="item[1]"
            [expanded]="expanded" />
        </div>
      } @else {
        <details
          [attr.open]="expanded ? true : null"
          [class.array]="isArray(item[1])">
          <summary>{{ item[0] | json }}:&nbsp;</summary>
          <wct-json
            [value]="item[1]"
            [expanded]="expanded" />
        </details>
      }
    }
  </div>
  <div>{{ isArray() ? ']' : '}' }}</div>
} @else {
  <span>{{ '{}' }}</span>
}
